import { render, staticRenderFns } from "./PublicProducts.vue?vue&type=template&id=2d829a8e&scoped=true"
import script from "./PublicProducts.vue?vue&type=script&lang=js"
export * from "./PublicProducts.vue?vue&type=script&lang=js"
import style0 from "./PublicProducts.vue?vue&type=style&index=0&id=2d829a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d829a8e",
  null
  
)

export default component.exports